import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    inline-flex items-center justify-center w-full
    px-8 py-5
    font-bold text-lg uppercase tracking-wide
    rounded-lg
    bg-brand-cta text-white
    hover:bg-brand-cta/90 hover:shadow-xl
    transition-all duration-200
    ${className}
  `;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-37">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-38">
      {children}
    </button>;
}